"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const lit_1 = require("lit");
const component_1 = require("@/components/domains/component");
const base_layouts_1 = require("@/components/layouts/base-layouts");
require("./home.css");
const platformReferences = [
    {
        href: 'https://developer.apple.com/design/human-interface-guidelines/components/layout-and-organization/disclosure-controls',
        label: 'Apple HIG - Disclosure Controls',
    },
    {
        href: 'https://developer.apple.com/documentation/technologies',
        label: 'Apple Developer - Technologies',
    },
    {
        href: 'https://developer.apple.com/kr/design/tips/',
        label: 'Apple - Design Tips',
    },
    {
        href: 'https://developer.android.com/reference',
        label: 'Android - API Reference',
    },
    {
        href: 'https://m3.material.io/foundations/layout/breakpoints/overview',
        label: 'MD3 - Layout Breakpoints',
    },
    {
        href: 'https://m3.material.io/foundations/interaction-states',
        label: 'MD3 - Interaction States',
    },
    {
        href: 'https://m3.material.io/blog/building-with-m3-expressive',
        label: 'MD3 - Building with M3 Expressive',
    },
];
const generalReferences = [
    {
        href: 'https://react.dev/learn/preserving-and-resetting-state',
        label: 'React - Preserving and Resetting State',
    },
    { href: 'https://www.digitala11y.com/', label: 'Digital A11Y' },
    {
        href: 'https://www.w3.org/WAI/ARIA/apg/',
        label: 'WAI-ARIA APG',
    },
    {
        href: 'https://en.wikipedia.org/wiki/Universal_design',
        label: 'Wikipedia - Universal Design',
    },
    { href: 'https://html.spec.whatwg.org/', label: 'WHATWG - HTML Spec' },
    {
        href: 'https://www.sitemaps.org/protocol.html',
        label: 'Sitemaps.org - Protocol',
    },
    {
        href: 'https://w3c.github.io/wcag/understanding/target-size-minimum.html',
        label: 'W3C - Target Size Minimum',
    },
    {
        href: 'https://simplicable.com/new/visual-information',
        label: 'Simplicable - Visual Information',
    },
    {
        href: 'https://codelabs.developers.google.com/codelabs/the-lit-path?hl=ko#0',
        label: 'Google Codelabs - The Lit Path',
    },
    {
        href: 'https://developer.mozilla.org/ko/docs/Web/Accessibility/Guides/Understanding_WCAG',
        label: 'MDN - Understanding WCAG',
    },
    {
        href: 'https://www.atlassian.com/ko/work-management/knowledge-sharing/documentation',
        label: 'Atlassian - Documentation',
    },
    {
        href: 'https://getdesign.md/',
        label: 'Get Design MD',
    },
];
const componentReferences = [platformReferences, generalReferences];
const supplementaryReferences = [
    {
        href: 'https://www.uber.com/us/en/blog/design-system-at-scale/',
        label: 'Uber - Design System at Scale',
    },
];
const samplerSections = [
    {
        id: 'sampler-intent',
        label: 'Intent',
        heading: 'Observe visible sections',
        description: 'The controller owns IntersectionObserver setup and updates the active section as the panel scrolls.',
    },
    {
        id: 'sampler-root',
        label: 'Root',
        heading: 'Use a local scroll root',
        description: 'This sampler passes its inner scroll area as the observer root, so the behavior stays contained in the page sample.',
    },
    {
        id: 'sampler-update',
        label: 'Update',
        heading: 'Refresh targets after render',
        description: 'The page setup reads target elements after the HTML is rendered and lets the controller observe those sections.',
    },
    {
        id: 'sampler-cleanup',
        label: 'Cleanup',
        heading: 'Keep document scroll stable',
        description: 'Trigger buttons scroll only this inner panel, so clicking Intent, Root, Update, or Cleanup does not move the document.',
    },
];
const samplerOptions = samplerSections.map(({ id, label }) => ({ value: id, label }));
const designSystemThoughts = [
    {
        heading: '디자인 시스템도 린하게',
        body: '제품은 린하게 만들면서 디자인 시스템은 왜 린하지 않은가. 디자인 시스템에 대해 더 적게 이야기하고, 디자인 토큰에 대해 더 많이 이야기하자. 디자인 시스템에 대한 이야기는 갖춰야 할 것의 목록으로 불어나지만, 토큰에 대한 이야기는 무엇을 한 곳에서 결정하고 바꿀지로 좁혀진다. 결정이 한 곳에 모이면 일관성은 저절로 따라온다.',
    },
    {
        heading: '결정은 토큰에',
        body: '디자인 토큰을 모든 플랫폼에 일관되게 적용한다는 것은 거대담론이다. 먼저 할 일은 변경하기 쉽게 정의하고 추상화하는 것이다. 제품이 린하게 동작할 수 있는 최소 기능과 최대 효율은 컴포넌트가 아니라 어쩌면 토큰에서 나온다.',
    },
    {
        heading: '안정된 구조, 두렵지 않은 중복',
        body: '변경이 쉽도록 구조는 안정되게 두고, 중복을 두려워하지 않는다.',
    },
    {
        heading: '규칙은 기본값이다',
        body: '우리가 해결하려는 궁극적인 문제는 유저 인터페이스가 아니다. 세부사항에 대한 논의를 줄이자면서 규칙을 깰 이유는 없다. 출시를 앞당기거나 성과를 측정할 수 있다면 깰 수 있고, 새로운 규칙은 언제든 실험할 수 있다. 판을 뒤흔들고 싶다면 설득은 프로덕트 디자이너의 몫이다.',
    },
    {
        heading: '적게 디자인하기',
        body: '기술의 한계를 받아들이고, 새로운 학습이 필요한 인터페이스를 최소화한다.',
    },
    {
        heading: '문서보다 피드백',
        body: '문서의 완결성에 집착하지 않는다. 대신 동료의 피드백을 잘 모은다.',
    },
];
const sharedStyleModules = [
    {
        module: 'list-item.styles',
        usageCount: 8,
        description: (0, lit_1.html) `
      ${(0, component_1.code)('interactiveRowStyles')}: 눌리는 행의 hover·포커스·선택·비활성 스킨. menu-item 계열과
      사이드바·검색 목록이 이 위에 선다
    `,
    },
    {
        module: 'dot.styles',
        usageCount: 6,
        description: (0, lit_1.html) `
      ${(0, component_1.code)('dotStyles')}와 크기·tone 단계: 점 모양과 조합 컴포넌트가 고르는 단계
    `,
    },
    {
        module: 'surface.styles',
        usageCount: 7,
        description: (0, lit_1.html) `
      ${(0, component_1.code)('surfaceBaseStyles')}: 면 선언. faq·banner·radio
      card·code-block·pager·token-item·color-token이 자기 요소에 얹는다
    `,
    },
    {
        module: 'input.styles',
        usageCount: 5,
        description: (0, lit_1.html) `
      ${(0, component_1.code)('visuallyHiddenInputStyles')}: radio·checkbox가 네이티브 input을 숨기는 조각. 입력 필드
      스타일은 input 계열 안에서만 쓴다
    `,
    },
    {
        module: 'tag.styles',
        usageCount: 5,
        description: (0, lit_1.html) `
      ${(0, component_1.code)('TagTone')}: tone 이름과 색. dot·chart가 tag와 같은 색을 맞출 때 쓴다
    `,
    },
    {
        module: 'button.styles',
        usageCount: 4,
        description: (0, lit_1.html) `
      ${(0, component_1.code)('buttonBaseStyles')} · ${(0, component_1.code)('buttonSelectedStyles')}: 버튼 골격과 눌림 스킨.
      icon-button 스타일이 이 위에 서서 아이콘 버튼 계열까지 퍼진다
    `,
    },
];
const renderSharedStyleCard = ({ module, usageCount, description }) => (0, lit_1.html) `
  <mm-surface>
    <mm-flex direction="column" gap="2" align-items="flex-start">
      <mm-tag>${usageCount}곳에서 사용</mm-tag>
      <mm-text-block level="4" heading=${module}>
        <mm-text size="14">${description}</mm-text>
      </mm-text-block>
    </mm-flex>
  </mm-surface>
`;
// 임시 전시: MoreMenu·CommentItem 패턴을 React 컴포넌트로 옮긴 모습
const reactMoreMenuCode = `const MENU_ACTIONS: MoreMenuAction[] = [
  { value: 'edit', label: '수정' },
  { value: 'delete', label: '삭제', tone: 'danger' },
]

function CommentItem({ onEdit, onDelete, ...props }: CommentItemProps) {
  const handleMenuAction = (value: string) => {
    if (value === 'edit') onEdit?.()
    if (value === 'delete') onDelete?.()
  }

  return <MoreMenu aria-label="댓글 메뉴" actions={MENU_ACTIONS} onAction={handleMenuAction} />
}

// 페이지
<CommentItem onEdit={() => alert('수정 clicked')} onDelete={() => alert('삭제 clicked')} />`;
const main = (0, lit_1.html) `
  <mm-main>
    <mm-flex direction="column" gap="section">
      <mm-flex gap="8" direction="column">
        <mm-heading level="1">
          Design System
          <br />
          Side Project
        </mm-heading>
        <mm-text-list
          .texts=${['Web Component - Lit', 'Github Actions', 'Constraint-driven design']}
        ></mm-text-list>
      </mm-flex>

      <div hidden>
        <mm-surface>
          <mm-text size="24" weight="bold" as="h2">Scroll Spy Sampler</mm-text>
          <div class="scroll-spy-sampler js-scroll-spy-sampler">
            <mm-toggle-button-group
              class="js-scroll-spy-nav"
              aria-label="Scroll spy sampler"
              orientation="vertical"
              stretch
              .options=${samplerOptions}
              value=${samplerOptions[0].value}
            ></mm-toggle-button-group>
            <mm-scroll
              direction="column"
              gap="3"
              class="scroll-spy-sampler-body js-scroll-spy-body"
              tabindex="0"
            >
              ${samplerSections.map(section => (0, lit_1.html) `
                  <mm-surface
                    id=${section.id}
                    class="scroll-spy-sampler-section"
                    data-scroll-spy-section
                  >
                    <mm-text-block
                      level="3"
                      heading=${section.heading}
                      description=${section.description}
                    ></mm-text-block>
                  </mm-surface>
                `)}
            </mm-scroll>
          </div>
        </mm-surface>
      </div>

      <mm-content-section-list>
        <mm-content-section heading="디자인 시스템에 대한 생각">
          <mm-paragraph>틀릴 수도 있지만 오랫동안 고민한 것들.</mm-paragraph>

          <mm-content-section-list>
            ${designSystemThoughts.map(({ heading, body }) => (0, lit_1.html) `
                <mm-content-section heading-level="3" heading=${heading}>
                  <mm-paragraph>${body}</mm-paragraph>
                </mm-content-section>
              `)}
          </mm-content-section-list>
        </mm-content-section>

        <mm-content-section heading="Meta Guidelines">
          <mm-paragraph>
            모든 것을 문서화하지 않는다. 반복해서 참조되고 자주 수행하는 것만 문서로 남긴다.
          </mm-paragraph>

          <mm-text-list
            variant="check"
            .texts=${[
    '문서화할 가치가 있다고 판단하려면 특정 횟수(예: 3회)만큼 발생해야 합니까?',
    '자주(예: 월 1회 이상) 프로세스를 수행해야 합니까?',
]}
          ></mm-text-list>

          <mm-content-section heading-level="3" heading="컴포넌트 페이지 디스크립션 작성 가이드">
            <mm-text-list
              variant="check"
              .texts=${[
    '컴포넌트 페이지 설명은 무엇인지, 어떻게 동작하는지, 사용자에게 어떤 이득인지 순서로 쓴다.',
]}
            ></mm-text-list>
          </mm-content-section>

          <mm-content-section heading-level="3" heading="Prop 표">
            <mm-text-list
              variant="check"
              .texts=${[
    '컴포넌트 페이지의 prop 표는 손으로 적지 않는다. 스크립트가 컴포넌트 코드의 @property 선언을 읽어 표를 만든다(npm run manifest). 이름·타입·기본값이 코드 한 곳에서 나오므로 문서가 구현과 어긋나지 않는다.',
    '이벤트·slot·메서드는 선언에서 읽을 수 없어 페이지에 손으로 덧붙인다.',
    '부모가 대신 채우는 prop은 선언에 @internal을 달아 표에서 뺀다. 예: mm-step이 번호를 매기는 mm-step-item의 value',
    '만든 결과(src/generated)는 커밋하지 않는다. 설치·개발 서버·빌드 때마다 새로 만든다.',
]}
            ></mm-text-list>
          </mm-content-section>
        </mm-content-section>

        <mm-content-section heading="Code Conventions">
          <mm-text-list
            .texts=${[
    '이벤트 핸들러 메서드는 handle 뒤에 대상과 이벤트 종류를 이어 붙인다. 예: handleFilesChange, handleRemoveClick',
    "host의 role이 항상 같은 값이면 connectedCallback에서 setAttribute('role', ...)로 고정하고, 소비자마다 달라질 수 있을 때만 reflect되는 role prop으로 공개한다.",
    '그룹/합성 컴포넌트는 자식의 change를 그대로 흘려보내지 않고 stopPropagation으로 끊은 뒤 자기 단위의 change로 다시 발행한다.',
    'render() 안의 조건부 DOM 조각이 커지면 render*() helper로 분리하고, render()에는 각 helper를 직접 나열한다.',
    'render*() 이름은 상태를 다시 중계하지 않고 실제 조각의 의미를 드러낸다. 예: renderContent()가 아니라 renderImage()',
    '파생 컴포넌트는 기반의 성격에 따라 조합 방식을 고른다. 상호작용·접근성 의미가 없는 기반은 그대로 렌더해 prop으로 단계를 고르고, 상호작용과 접근성 이름을 가진 기반은 공유 스타일·템플릿 조각을 조합한다. 후자를 렌더하면 shadow가 한 단계 깊어지고 이름·상태·이벤트를 안쪽으로 중계해야 하기 때문이다. 예: mm-current-indicator는 mm-dot을 렌더하고, mm-dismiss-button은 iconButtonStyles와 renderIconAction을 조합한다.',
    '화면 위로 뜨는 표면은 동작과 표현을 분리한다. 배경을 막는지, 무엇으로 닫는지, 트리거와 어떻게 이어지는지는 SheetController·DisclosureController 같은 컨트롤러가 맡고, 패널 재질·너비·placement는 각 컴포넌트가 공유 스타일을 조합해 정한다. 표면이 달라도 열고 닫는 방식이 같아진다.',
]}
          ></mm-text-list>
          <mm-content-section heading-level="3" heading="계열 밖에서 재사용되는 스타일 모듈">
            <mm-grid columns="3" gap="4">${sharedStyleModules.map(renderSharedStyleCard)}</mm-grid>
          </mm-content-section>
        </mm-content-section>

        <mm-content-section heading="Accessibility Notes">
          <mm-text-list
            .texts=${[
    'role="menu" 안에는 menuitem, menuitemcheckbox, menuitemradio와 이를 묶는 group, separator만 둘 수 있다.',
    'menuitemradio는 menu·menubar(또는 그 안의 group) 안에서만 유효하다. menu가 아닌 곳(disclosure 패널 등)의 선택지는 radiogroup > radio로 둔다.',
    '항목의 role은 겉모습이 아니라 놓인 부모로 정한다. 같은 모양의 행도 menu 안이면 menuitemradio, 밖이면 radio다.',
    'menu는 선택 즉시 닫혀야 하는 개념이 아니다. APG 기준 Enter는 실행 후 닫고, Space는 menuitemcheckbox·menuitemradio의 상태만 바꾸고 연 채로 둔다.',
    'disclosure는 aria-expanded로 영역을 여닫는 패턴일 뿐 위치를 정하지 않는다. 트리거에 앵커되어 뜨면 popover, 화면을 덮으면 sheet로 표면을 따로 고른다.',
    'role="list" 안에는 listitem만 둘 수 있다. 그래서 목록 그룹 안에 제목을 넣으면 제목 요소로 읽히게 둘 수 없고, 화면에만 그린 뒤 같은 문구를 aria-label로 옮겨야 한다.',
    '제목 달린 목록은 목록 그룹(mm-list-item-group)이 제목을 받지 않고, 쓰는 쪽이 mm-heading에 id를 주고 그룹에 aria-labelledby로 연결한다. 그룹이 제목을 받아 aria-label로 옮기면 그룹이 목록의 접근성 이름까지 정하게 되어 책임이 커지고, 쓰는 쪽이 준 aria-label과 충돌하며, heading prop이 aria-label의 별칭이 된다. 제목도 heading 요소가 아니게 되어 제목 단위로 건너뛰는 탐색을 잃는다.',
]}
          ></mm-text-list>
        </mm-content-section>
      </mm-content-section-list>

      <mm-component-references .items=${componentReferences}></mm-component-references>
      <mm-component-references
        heading="보완 영역"
        .items=${supplementaryReferences}
      ></mm-component-references>

      <mm-content-section heading="React로 옮긴 MoreMenu 패턴">
        <mm-code-block language="typescript" .code=${reactMoreMenuCode}></mm-code-block>
      </mm-content-section>

      <mm-content-section heading="Event Notes">
        <mm-text-list
          .texts=${[
    '버블링은 이벤트가 낸 요소에서 끝나지 않고 부모, 그 부모, document까지 차례로 올라가는 것이다. 그래서 조상 어디에 리스너를 달아도 받을 수 있다.',
    'toggle은 "이 요소가 열렸다/닫혔다"는 자기 상태 알림이라 버블링하지 않는다. 네이티브 details·popover의 toggle도 버블링하지 않는다.',
    '같은 이름의 이벤트가 버블링하면 섞인다. 시트 안에 select를 두고 시트에 toggle 리스너를 달면, select 목록이 닫힐 때의 toggle이 시트까지 올라와 시트가 닫힌 것처럼 처리된다.',
    'change·input은 네이티브처럼 버블링한다. 폼이나 그룹이 자식의 값 변경을 위에서 받아야 하기 때문이다. 기준은 같은 이름의 네이티브 이벤트와 같은 전파 방식이다.',
    '받는 쪽에서 e.target === e.currentTarget로 거르는 건 보조책이다. 모든 소비처가 챙겨야 하고, shadow DOM 경계를 넘으면 target이 호스트로 바뀌어(retarget) 걸러지지 않는 경우가 있다. 전파 범위는 이벤트를 내는 컴포넌트가 정한다.',
    '"닫아 달라"는 요청과 "닫혔다"는 알림을 이벤트 하나로 겸하지 않는다. 시트 헤더의 닫기 버튼은 시트의 close()를 직접 부르고, 시트는 닫힌 뒤 toggle로 알린다.',
]}
        ></mm-text-list>
      </mm-content-section>
    </mm-flex>
  </mm-main>
`;
(0, base_layouts_1.renderPage)(main, {
    footer: true,
    initialize: () => {
        setupScrollSpySampler();
    },
});
function setupScrollSpySampler() {
    const sampler = document.querySelector('.js-scroll-spy-sampler');
    if (!sampler)
        return;
    const scrollRoot = sampler.querySelector('.js-scroll-spy-body');
    const nav = sampler.querySelector('.js-scroll-spy-nav');
    const targets = Array.from(sampler.querySelectorAll('[data-scroll-spy-section]'));
    if (!scrollRoot || !nav || !targets.length)
        return;
    const observer = new IntersectionObserver(entries => {
        const visible = entries
            .filter(entry => entry.isIntersecting)
            .sort((a, b) => a.boundingClientRect.top - b.boundingClientRect.top);
        if (visible.length)
            nav.value = visible[0].target.id;
    }, { root: scrollRoot, rootMargin: '0px 0px -55% 0px' });
    targets.forEach(target => observer.observe(target));
    nav.addEventListener('change', event => {
        const target = document.getElementById(event.detail.value);
        if (!target)
            return;
        const top = target.getBoundingClientRect().top -
            scrollRoot.getBoundingClientRect().top +
            scrollRoot.scrollTop;
        scrollRoot.scrollTo({ top, behavior: 'smooth' });
    });
}
//# sourceMappingURL=data:application/json;base64,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